import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Trust from './components/Trust';
import Reviews from './components/Reviews';
import About from './components/About';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black font-sans">
      <Header />
      <main>
        <Hero />
        <Services />
        <Trust />
        <Reviews />
        <About />
        <CTA />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
